import Logo from "../assets/img/logo.png";
import { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa"; 
import { Link } from "react-router-dom";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Cookies from 'universal-cookie';

const Login = () => {
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    let navigate = useNavigate();

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
const login=async()=>{
    const dataFile = await axios.post("https://assistant.bordarna.ir/login", {
        email: email,
        password: password
    });
    if (dataFile?.status == 200 || dataFile?.status == 204 || dataFile?.status == 201) {
        // const pieces = dataFile?.data?.split('/')
        // props.setFiles(true)
        console.log(123)
        console.log(dataFile.data)
        const cookies = new Cookies();
        cookies.set('token', dataFile.data.access_token, { path: '/' });
        cookies.set('name', email, { path: '/' });
        // navigate('/selectType')
        navigate('/chatBot')
        // setSnipper(false)
    }
    else {
        console.log(dataFile)
        // setSnipper(false)

        alert("نام کاربری یا رمز عبور نادرست می باشد");
    }
}
    return (
        <div className="h-screen flex flex-col justify-center items-center bg-gray-100 hasBackgroud">
                 <div className="hidden lg:block w-[70%] lg:w-[95%] max-w-[400px] text-left mb-4">
            <a
                    href="/signup" 
                    className=" text-[#f4752a] text-[14px] border-b border-dashed pb-1 font-IRANYekanMedium hover:text-[#000]"
                >
                    حساب کاربری ندارید؟ ثبت نام کنید
                </a>
            </div>
            <div className="bg-white w-[70%] lg:w-[95%] max-w-[400px] rounded-xl p-6 shadow-lg flex flex-col items-start relative">
            <a
                    href="/signup" 
                    className="block lg:hidden absolute top-4 left-4 text-[#f4752a] text-[14px] border-b border-dashed  font-IRANYekanMedium hover:text-[#000]"
                >
                   حساب کاربری ندارید؟ ثبت نام کنید
                </a>
                <img src={Logo} className="w-[80px] mb-4 mt-6 mx-auto block " alt="logo" />
                <h2 className="text-[15px] font-IRANYekanExtra mb-2 text-center mx-auto">به دستیار هوشمند بانک سپه خوش آمدید!</h2>
                <h2 className="text-[18px] font-IRANYekanExtra text-[#f4752a] text-center mx-auto">ورود به سامانه</h2>

                

           
                <p className="text-gray-600 mt-4 mb-2 font-IRANYekanMedium text-right">لطفا ایمیل خود را وارد کنید</p>
                <input
                    className="border p-2 rounded-lg w-full text-right font-IRANYekanMedium inputF border-[#c7c7c7]"
                    type="email"
                    placeholder="ایمیل خود را وارد کنید"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />

              
                <p className="text-gray-600 mt-4 mb-2 font-IRANYekanMedium text-right">لطفا رمز عبور خود را وارد کنید</p>
                <div className="relative w-full">
                    <input
                        className="border p-2 rounded-lg w-full text-right font-IRANYekanMedium inputF border-[#c7c7c7]"
                        type={showPassword ? "text" : "password"}
                        placeholder="رمز عبور خود را وارد کنید"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <button
                        className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-500 "
                        onClick={togglePasswordVisibility}
                    >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </button>
                </div>

          
                <button onClick={()=>login()}
                    className="bg-[#f4752a] w-full font-IRANYekanExtra text-white px-4 py-2 rounded-lg mt-4 hover:bg-[#000]"
                >
                    <p to={'/selectType'}>
                    ورود
                    </p>
                    
                </button>
            </div>
        </div>
    );
};

export default Login;